module.exports = __webpack_public_path__ + "static/impact-359b3f108e5e5ff337038360ab6e12e7.png";